import { Component, OnInit } from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {BehaviorSubject, interval, ReplaySubject, Subscription} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Profile} from "../../interface/profile";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-login-lock-timer',
  templateUrl: './login-lock-timer.component.html',
  styleUrls: ['./login-lock-timer.component.scss']
})
export class LoginLockTimerComponent implements OnInit {
  private countdownSub?: Subscription;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  public countdown$ = new BehaviorSubject<string>('00:00');
  public showExtendPopup$ = new BehaviorSubject<boolean>(false);
  public sessionExpired$ = new BehaviorSubject<boolean>(false);

  profile: Profile;


  constructor(
    private _authService: AuthService,
    private dialogRef: MatDialogRef<LoginLockTimerComponent>
  ) {
    this._authService.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });
  }

  ngOnInit(): void {
    this.startCountdown();
  }

  startCountdown(): void {
    let validUntilStr = this.profile.loginLock;

    validUntilStr = validUntilStr.replace(' ', 'T');


    if (!validUntilStr.endsWith('Z') && !validUntilStr.includes('+')) {
      validUntilStr += 'Z';
    }

    const validUntil = new Date(validUntilStr).getTime();

    this.countdownSub?.unsubscribe();

    this.countdownSub = interval(1000).subscribe(() => {
      const now = Date.now();
      const diff = validUntil - now;

      if (diff <= 0 && this.profile.roles[0] !== 'ROLE_ADMIN') {
        this._authService.logout();
      }

      if (diff <= 0) {
        this.countdown$.next('00:00');
        this.showExtendPopup$.next(false);
        this.countdownSub?.unsubscribe();
        this.sessionExpired$.next(true);

        return;
      }

      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      this.countdown$.next(
        `${this.pad(minutes)}:${this.pad(seconds)}`
      );
      if (this.countdown$.getValue() === '00:00') {
        this.dialogRef.close();
      }
    });
  }

  private pad(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

}
